export const FEED_QUERY_PARAM_NAME = 'feedType';
